import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

export default class Label extends Component {
    render() {
        const {
            size,
            round,
            label,
            color,
            privilege,
            product,
            closable,
            closeCb,
            className,
            isPill,
            noWrap,
            plan,
            testId,
            ...rest
        } = this.props;
        const classes = cl(
            'label',
            { 'label--round': round },
            size ? `label--${size}` : null,
            product ? `label--${product}` : null,
            color ? `label--${color}` : null,
            privilege ? `label--${privilege}` : null,
            isPill ? 'label--pill' : null,
            noWrap ? 'label--nowrap' : null,
            plan ? `label--${plan}` : null,
            className
        );
        return (
            <span className={classes} data-testid={testId} {...rest}>
                {label && (
                    <span className="label__name" data-testid={`${testId}-label`}>
                        {label}
                    </span>
                )}
                {closable && (
                    <Button
                        type="link-flex"
                        className="icon--thicker"
                        iconSize={10}
                        icon="close"
                        onClick={closeCb}
                        testId={`${testId}-button`}
                    />
                )}
            </span>
        );
    }
}

Label.defaultProps = {
    size: undefined,
    label: '',
    color: undefined,
    privilege: undefined,
    className: '',
    product: undefined,
    round: false,
    closable: false,
    closeCb: null,
    isPill: null,
    noWrap: null,
    plan: undefined,
    testId: 'label',
};

Label.propTypes = {
    label: PropTypes.string,
    testId: PropTypes.string,
    color: PropTypes.oneOf([
        'blue',
        'lightblue',
        'mauve',
        'lightmauve',
        'green',
        'lightgreen',
        'grey',
        'lightgrey',
        'orange',
        'lightorange',
        'red',
        'lightred',
        'dark',
        'white',
        undefined,
        '',
    ]),
    className: PropTypes.string,
    product: PropTypes.oneOf([
        'localities',
        'geolocation',
        'distance',
        'stores',
        'address',
        'map',
        'mapping',
        'merchants',
        'traffic',
        'indoor',
        'w3w',
        undefined,
    ]),
    plan: PropTypes.oneOf(['free', 'standard', 'enterprise', 'enterprise--free', undefined]),
    size: PropTypes.oneOf(['small', 'mini', 'nano', undefined]),
    privilege: PropTypes.oneOf(['superuser', 'staff', 'owner', 'co-owner', undefined]),
    round: PropTypes.bool,
    closable: PropTypes.bool,
    closeCb: PropTypes.func,
    isPill: PropTypes.bool,
    noWrap: PropTypes.bool,
};
